import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {InstructionsComponent} from "./instructions/instructions.component";
import {StateOfResidenceComponent} from "./state-of-residence/state-of-residence.component";
import {EsignDisclosureComponent} from "./esign-disclosure/esign-disclosure.component";
import {PolicyNumberComponent} from "./policy-number/policy-number.component";
import {CoverageComponent} from "./coverage/coverage.component";
import {ApplicantTypeComponent} from "./applicant-type/applicant-type.component";
import { MhsComponent } from './mhs/mhs.component';
import { ReviewComponent } from './review/review.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { DeactivateGuard } from './deactivate.guard';
import { NotFoundComponent } from './not-found/not-found.component';
import { InvalidPolicyNumberComponent } from './invalid-policy-number/invalid-policy-number.component';
import { AuthGuardService } from './shared/service/auth-guard.service';
import { ConsentComponent } from './consent/consent.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';

export const routes: Routes = [
  { path: 'instructions', component: InstructionsComponent, canActivate: [AuthGuardService] },
  { path: 'instructions/:timeout', component: InstructionsComponent, canActivate: [AuthGuardService] },
  { path: 'policy', component: PolicyNumberComponent, canDeactivate: [DeactivateGuard], canActivate: [AuthGuardService] },
  { path: 'consent', component: ConsentComponent },
  { path: 'state-of-residence', component: StateOfResidenceComponent, canDeactivate: [DeactivateGuard], canActivate: [AuthGuardService] },
  { path: 'esign-disclosure', component: EsignDisclosureComponent, canDeactivate: [DeactivateGuard], canActivate: [AuthGuardService]},
  { path: 'applicant-type', component: ApplicantTypeComponent, canDeactivate: [DeactivateGuard], canActivate: [AuthGuardService] },
  { path: 'coverage', component: CoverageComponent, canDeactivate: [DeactivateGuard], canActivate: [AuthGuardService] },
  { path: 'mhs', redirectTo: 'employee-information', pathMatch: 'full' },
  { path: 'employee-information', component: MhsComponent, canDeactivate: [DeactivateGuard], canActivate: [AuthGuardService] },
  { path: 'applicant-information', component: MhsComponent, canDeactivate: [DeactivateGuard], canActivate: [AuthGuardService] },
  { path: 'medical-history', component: MhsComponent, canDeactivate: [DeactivateGuard], canActivate: [AuthGuardService] },
  { path: 'physician-information', component: MhsComponent, canDeactivate: [DeactivateGuard], canActivate: [AuthGuardService] },
  { path: 'authorization', component: MhsComponent, canDeactivate: [DeactivateGuard], canActivate: [AuthGuardService] },
  { path: 'electronic-communication', component: MhsComponent, canDeactivate: [DeactivateGuard], canActivate: [AuthGuardService] },
  { path: 'review', component: ReviewComponent, canDeactivate: [DeactivateGuard], canActivate: [AuthGuardService] },
  { path: 'confirmation', component: ConfirmationComponent, canDeactivate: [DeactivateGuard], canActivate: [AuthGuardService] },
  { path: 'maintenance', component: MaintenanceComponent, canActivate: [AuthGuardService]},
  { path: 'page-not-found', component: NotFoundComponent},
  { path: 'invalid-policy-number', component: InvalidPolicyNumberComponent},
  { path: ':policyId', component: InstructionsComponent},
  { path: '', redirectTo: 'instructions', pathMatch: 'full' },

  { path: '**', redirectTo: 'page-not-found'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {}), RouterModule.forRoot(routes, {scrollPositionRestoration: 'top'})],
  exports: [RouterModule]
})
export class AppRoutingModule {
  constructor(private authGuardService: AuthGuardService){
    this.authGuardService.initializeEventListeners();
    this.authGuardService.checkMaintenance();
  }
 }
